//==============================================================================
//? Rewrite so that csv/pdf blob is created and sent as parm?
// Emails a report using report distribution settings
//
// Passed:
//  1. reportDefRef
//  2. emailFileAttachments - An array containing the CSV/PDF blob(s) to attach
//==============================================================================
import React, { useContext, useState, useEffect } from "react";

import {
  notificationSuccess,
  notificationError
} from '../../../../utils/notification'

//Components
import { exportToCSV } from "../common/ExportToCSV"
import { exportToPDF } from "../common/ExportToPDF"

//Operations
import { SEND_REPORT_EMAIL } from "../../../../operations/queries/reportBuilder/common";

export const EmailReport = async (  //Add silent option so that it can be called by batch process andwon't display errors?
  Auth,
  Apollo,
  reportDefRef,
  reportTableColumns, 
  reportTableExtraData,

  //emailFileAttachments, 

) => {  
  const reportDistribution = reportDefRef.current.distribution

  //At least one email recipient
  if (!reportDistribution.emailRecipients || reportDistribution.emailRecipients?.length === 0) {
      notificationError('At least one Email recipient required')
      console.log('no recipients')
      return
  }

  //At least one from email (only 1?)
  if (!reportDistribution.emailFrom || reportDistribution.emailFrom?.length === 0) {
      notificationError('A "From" Email is required')
      console.log('no from email') //Better messaging
      return
  }

  //Require a report attachement (Do this?)
  if (!reportDistribution.emailAttachments || reportDistribution.emailAttachments?.length === 0) {
    notificationError('A Pdf or CSV attachment is required')
      console.log('no selections') //Better messaging
      return
  }

  //Get email props
  const userId = Auth.userId
  const emailTo = reportDistribution.emailRecipients.map(recipient => recipient.email) //SendGrid wants an array of strings for multiple 'to' addresses
  const emailFrom = reportDistribution.emailFrom
  const emailSubject = reportDistribution.emailSubject
  const emailText = reportDistribution.emailText

  //Get blobs of the requested pdf/csv attachements
  let emailFileAttachments = []

  if (reportDistribution?.emailAttachments.includes('csv')) {
    //Need to wait for returned blob promise to finish
    await exportToCSV(reportDefRef.current, reportTableColumns, reportTableExtraData, 'blob')  //returns pdfBlob.text() - utf-8 text of content
    //await getCsv('blob') //returns pdfBlob.text() - utf-8 text of content
    .then(result => {
      //NOTE: unescape is deprecated.  Need to find alternative.
      const encodedBlob = btoa(unescape(encodeURIComponent(result))) //base64 encode
      emailFileAttachments.push({
      content: encodedBlob,
      filename:
          reportDefRef?.current?.reportName !== undefined ? reportDefRef?.current?.reportName + '.csv' : 'Untitled_Report.csv',
      type: 'text/csv',
      disposition: 'attachment'
      })
    })
    .catch(error => console.log(error))
  }

  if (reportDistribution.emailAttachments.includes('pdf')) {
      //Need to wait for returned blob promise to finish
      //await getPdf('blob') //returns pdfBlob.text() - utf-8 text of content

      await exportToPDF(reportDefRef, reportTableColumns, reportTableExtraData, "blob")
      .then(result => {
        //NOTE: unescape is deprecated.  Need to find alternative.
        const encodedBlob = btoa(unescape(encodeURIComponent(result))) //base64 encode
        emailFileAttachments.push({
        content: encodedBlob,
        filename:
        reportDefRef?.current?.reportName !== undefined ? reportDefRef?.current?.reportName + '.pdf'  : 'Untitled_Report.pdf',
        type: 'application/pdf',
        disposition: 'attachment'
        })
      })
      .catch(error => console.log(error))
  }

  //Send the email using sendgrid
  console.log('EmailReport-before send',emailTo,emailFileAttachments)
  try {
    const {response} = await Apollo.client.query({
      query: SEND_REPORT_EMAIL,
      variables: {
        userId: userId,
        to: emailTo,
        from: emailFrom,
        subject: emailSubject,
        text: emailText,
        attachments: emailFileAttachments
      }
    })
    await response
    notificationSuccess('Your report has been sent.')
  } catch (error) {
      console.log(error)
      const message =
      error?.metadata?.graphQLErrors?.[0]?.message ||
      error?.message ||
      'An unknown error occurred, please contact your administrator. E006'
      notificationError(
      'Your email was not sent because the following error occurred:',
      message + '.'
      )
  }
}
